module.exports = "/_next/static/images/6ef3517ea779b81d34451f6225246bb0-mgm-invite-ticket-6.jpg.webp";